import { Helmet } from 'react-helmet-async';
import { useState, useMemo, createElement, useEffect } from 'react';
import { Button, Container, Stack } from '@mui/material';

import { Iconic } from '@/commons/iconic';
import { useQuery } from '@tanstack/react-query';
import ListPage from '@/components/Table';
import { getHistoryCashRegister } from '@/services/cash-register';
import { usePaginator } from '@/modules/orders/hooks/usePaginator';
import { paginatorData } from '@/components/Table/types/pagination';
import { useCashRegisterContext } from '@/hooks/useCashRegisterContext';
import { DatePicker } from '@mui/x-date-pickers';
import { useDatesValidation } from '@/hooks/useDatesValidation';
import { translates } from '@/utils/translate';
import { CashRegister } from '../types';
import { TABLE_HEAD_CASH_REGISTER } from '../utils/constants';
import { CashRegisterCreatePage } from '../components/create-cash';
import { CashRegisterClosePage } from '../components/close-cash';
import { ListActionsCashRegister } from '../actions-list';
import { PATH_DASHBOARD } from '@/routes/paths';

export default function CashRegisterListPage() {
  const navigate_cash_register: any = {
    view: PATH_DASHBOARD['cash-register'].view,
    edit: PATH_DASHBOARD['cash-register'].edit,
  };
  const [open, setOpen] = useState(false);
  const { isOpen } = useCashRegisterContext();
  const { paginator, setPaginator } = usePaginator();
  const { disableDates, disabled, handleDates, dates } = useDatesValidation({});
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const title = 'Cash register';
  const { isLoading, data, refetch } = useQuery({
    queryKey: ['cash-register', 'all'],
    queryFn: () => getHistoryCashRegister(paginator.count, paginator.page, dates),

  });

  const Component = useMemo(
    () =>
      createElement(isOpen ? CashRegisterClosePage : CashRegisterCreatePage, {
        open,
        onClose: handleClose,
        selectedValue: '',
      }),
    [open, isOpen]
  );

  return (
    <>
      <Helmet>
        <title>
          {import.meta.env.VITE_TITLE_BUSINESS}: {title} List
        </title>
      </Helmet>

      <Container maxWidth={false}>
        <ListPage<CashRegister, number>
            toolbar={
              <Stack sx={{ display: 'flex', flexDirection: 'row', alignSelf: 'baseline', gap: 2 }}>
                <DatePicker
                    label={translates.startDate}
                    onChange={(date) => handleDates('initial', date)}
                />
                <DatePicker
                    label={translates.endDate}
                    shouldDisableDate={disableDates}
                    disabled={disabled}
                    onChange={(date) => handleDates('last', date)}
                />
              </Stack>
            }
          data={data?.data}
          navigateHandle={navigate_cash_register}
          actions={ListActionsCashRegister}
          isLoading={isLoading}
          dataStruct={TABLE_HEAD_CASH_REGISTER}
          paginator={{ refresh: refetch, setPaginator, paginator }}
        />
      </Container>
    </>
  );
}
